<template>
  <v-card
    flat
    outlined
    rounded
    elevation="1"
    class="journal d-flex flex-column fill-height"
  >
    <v-toolbar
      color="transparent"
      dense
      flat
      dark
      class="journal-header"
    >
      <v-toolbar-title class="light-blue--text text--lighten-1">
        Record Journal [{{ records.length }}]
      </v-toolbar-title>
      <v-btn
        small
        text
        color="light-blue lighten-1"
        class="ml-3"
        @click="showDetails = !showDetails"
      >
        <v-icon
          left
          small
        >
          {{ showDetails ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
        </v-icon>
        {{ showDetails ? 'Hide details' : 'Show details' }}
      </v-btn>

      <v-spacer />

      <div>
        <v-bottom-navigation 
          light 
          style="box-shadow: 0 0;height:40px"
        >
          <v-btn 
            v-if="min>0" 
            value="all"
            @click="max=max-100;min=min-100"
          >
            <span>Previous</span>
            <v-icon>mdi-rewind</v-icon>
          </v-btn>

          <v-btn 
            value="recent"
            @click="max=100;min=0;"
          >
            <span>{{ min + '/' + max }}</span>
            <v-icon>mdi-history</v-icon>
          </v-btn>

          <v-btn 
            v-if="records.length>max"
            value="all"
            @click="min=max;max=max+100"
          >
            <span>Next</span>
            <v-icon>mdi-fast-forward</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </div>
      <v-spacer />

      <v-chip
        v-if="journal.records.length > 0"
        label
        dark
        color="transparent"
        class="journal-duration text-subtitle-2"
      >
        <span class="light-blue--text text--lighten-1 text-no-wrap">
          <refreshable
            :lambda="() => journal.getPrettyDuration()"
            :interval="1000"
          />
          <v-icon
            right
            color="blue-grey lighten-3"
          >mdi-clock-time-ten-outline</v-icon>
        </span>
      </v-chip>
    </v-toolbar>

    <v-row
      class="fill-height overflow-y-hidden pa-2"
      no-gutters
    >
      <v-col class="fill-height overflow-y-auto overflow-x-hidden">
        <Record
          v-for="(record, index) in records.slice(min,max)"
          :key="index"
          :record="record"
          :catalog-values="catalogValues"
          :show-details="showDetails"
          class="no-gutters"
          @label:changed="$emit('label:changed', $event)"
        />
      </v-col>
    </v-row>
    <comment-editor />
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import Record from '@/components/journal/record'
import Refreshable from '@/components/refreshable'
import CommentEditor from '@/components/journal/comment_editor'

export default {
	name: 'Journal',

	components: {
		Record,
		Refreshable,
		CommentEditor,
	},
	props: {
          catalogValues: {
            type: Object,
            default: () => ({
              cat1: [],
              cat2: [],
              cat3: [],
              type: [],
            }),
          },
        },
        data: () => ({
    min: 0,
    max: 100,
    showDetails: false
  }),
	computed: {
		...mapState('journal', {
			journal: state => state.current,
		}),
		...mapGetters('journal', ['records']),
	},
}
</script>

<style lang="scss">
.journal {
	.journal-header > .v-toolbar__content {
		border-bottom: 2px solid #29b6f6; // light-blue lighten-1
		.journal-duration {
			opacity: 0.75;
		}
	}
}
</style>
